/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 云缴费配置信息
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: dictionary.CloudPayEndpoint;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/dictionary/cloud-pay-endpoints`,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
